import React, { useState, useEffect } from 'react'
import { formatDecimal, numberFormat, numberFormatDestroy } from '../../utility/Helpers'

const InputQuantity = (data) => {
  const [value, setValue] = useState(() => formatDecimal(data.value ?? 1, data.decimal ?? 0))

  const maximum = 10000000
  const allowDecimal = typeof data.decimal === 'number' && data.decimal > 0

  useEffect(() => {
    const formatted = formatDecimal(data.value ?? 1, data.decimal ?? 0)
    setValue(formatted)
  }, [data.value, data.decimal])

  const onChange = (e) => {
    e.preventDefault()
    const rawValue = e.target.value

    const commaCount = (rawValue.match(/,/g) || []).length
    const endsWithComma = rawValue.endsWith(',')

    if (!allowDecimal && commaCount > 0) return
    if (allowDecimal && commaCount > 1) return

    if (allowDecimal && rawValue.includes(',')) {
      const [, decimalPart = ''] = rawValue.split(',')
      if (decimalPart.length > data.decimal) return
    }

    const inputValue = numberFormatDestroy(rawValue)
    const numericValue = Number(inputValue)

    // validasi tetap dijalankan, tapi tampilkan raw value saat belum lengkap
    if (!isNaN(numericValue) && inputValue !== '') {
      let val = numericValue
      if (val > maximum) val = maximum
      if (!data.zeroMinValue) {
        if (val < 1) val = 1
      }

      const formatted = allowDecimal ? formatDecimal(val, data.decimal) : val
      data.onChange({ id: data.id, value: formatted })

      // tampilkan rawValue kalau user masih ngetik koma atau nol
      if (endsWithComma || /,\d*0*$/.test(rawValue)) {
        setValue(rawValue)
      } else {
        setValue(numberFormat(formatted))
      }
    } else {
      // Input belum lengkap, tetap tampilkan rawValue
      setValue(rawValue)
    }
  }

  const onChangeBlur = (e) => {
    e.preventDefault()
    const inputValue = numberFormatDestroy(e.target.value)
    if (inputValue === '') {
      const val = 1
      data.onChange({ id: data.id, value: val })
      setValue(numberFormat(val))
    }
  }

  const clickIncrease = () => {
    let val = Number(numberFormatDestroy(value))

    if (val < maximum) val += 1
    data.onChange({ id: data.id, value: val })
    setValue(numberFormat(val))
  }

  const clickDecrease = () => {
    let val = Number(numberFormatDestroy(value))
    if (val > 1) val -= 1
    data.onChange({ id: data.id, value: val })
    setValue(numberFormat(val))
  }

  return (
    <div className="input-group">
      <input
        type="text"
        value={value}
        onChange={onChange}
        onBlur={onChangeBlur}
        className="py-3 height-20 form-control"
        readOnly={data.readOnly}
      />
      <div className="input-group-append">
        <button
          className="btn p-2 btn-xs btn-secondary"
          onClick={clickDecrease}
          type="button"
          disabled={data.readOnly}
        >
          <i className="fas fa-minus" />
        </button>
        <button
          className="btn p-2 pr-3 btn-xs btn-secondary"
          onClick={clickIncrease}
          type="button"
          disabled={data.readOnly}
        >
          <i className="fas fa-plus" />
        </button>
      </div>
    </div>
  )
}

export default InputQuantity
